class SideBar extends HTMLElement {
  constructor() {
    super();
    this.openSidebar = document.querySelectorAll('[sidebar-open]');
    this.sideBar = this;
    this.close = this.querySelectorAll('.tw-close');
    let self = this;
    this.currentSideBarOpen = false;

    this.openSidebar.forEach((element) => {
      element.addEventListener('click', () => { 
        this.open(element)
      });
    });

    this.close.forEach(close => {
      close.addEventListener('click', function() {
        if(self.sideBar.classList.contains('sidebar-visible')) {
          self.sideBar.classList.remove("sidebar-visible");
          self.sideBar.classList.add("tw-hidden");
          self.scrollElements('unlock', self.querySelectorAll('.popup-content ul'));
        }
      });
    });

    subscribe(PUB_SUB_EVENTS.sidebarOpen, (event) => {
      this.open(event)
    });

  }

  open(element) {
    if (element.sidebar && element.sidebar !== 'side-bar') return;
    let currentHandleSidebarOpen = element.source ? element.source : element.getAttribute('sidebar-open');
    let currentSideBar = `side-bar[handle="${currentHandleSidebarOpen}"]`;

    this.currentSideBarOpen = document.querySelector(currentSideBar);

    this.currentSideBarOpen.classList.add("sidebar-visible");
    this.currentSideBarOpen.classList.remove("tw-hidden");

    this.scrollElements('lock', this.querySelectorAll('.popup-content ul'));
    document.addEventListener('click', this.closeOnClickOutside.bind(this));
  }

  scrollElements(action, selector) {
    if(action == 'lock') {
      selector.forEach(element => {
        scrollLock.disablePageScroll(element);
      });
    }

    if(action == 'unlock') {
      selector.forEach(element => {
        scrollLock.enablePageScroll(element);
      });
    }
  }

  closeOnClickOutside(event, action) {
    if (!event.target.closest('.sidebar-content')) {
        if (!Array.from(this.openSidebar).some(element => element.contains(event.target))) {
          if(this.sideBar.classList.contains('sidebar-visible')) {
            this.sideBar.classList.remove("sidebar-visible");
            this.sideBar.classList.add("tw-hidden")
          };
            this.scrollElements('unlock', this.querySelectorAll('.popup-content ul'));
            document.removeEventListener('click', this.closeOnClickOutside.bind(this));
        }
    }
  }
}

customElements.define('side-bar', SideBar);


/** Back in stock
* custom notify-popup
* https://help.backinstock.org/article/2303-javascript-api
**/
class notifyMePopup extends SideBar {
  constructor() {
      super();
      this.button          = this.querySelector('#notify_me');
      this.privacyField    = this.querySelector('.notify-me__privacy');
      this.privacy         = this.querySelector('#notify__privacy');
      this.newsletter      = this.querySelector('#notify__newsletter');
      this.email           = this.querySelector('#notify_email');
      this.select          = this.querySelector('#notify_variant');
      this.dialogContainer = this.querySelector('.dialog__container');
      this.dialog_notify   = this.querySelector(".dialog__notification");
      this.modalClose      = this.querySelector(".product-popup-modal__toggle");
      this.modal           = this.querySelector('.notifyme-popup.dialog.dialog__notify-me');
      this.modalOpen       = this.querySelector(".button-noProduct");

      this.addEvents();
  }

  open(element) {
    if (element.sidebar && element.sidebar !== 'notifyme-popup') return;
    let currentHandleSidebarOpen = element.source ? element.source : element.getAttribute('sidebar-open');
    let currentSideBar = `notifyme-popup[handle="${currentHandleSidebarOpen}"]`;
    this.currentSideBarOpen = document.querySelector(currentSideBar);
    if (!this.currentSideBarOpen) return

    this.currentSideBarOpen.classList.add("sidebar-visible");
    this.currentSideBarOpen.classList.remove("tw-hidden");

    this.scrollElements('lock', this.querySelectorAll('.popup-content ul'));
    document.addEventListener('click', this.closeOnClickOutside.bind(this));

    this.updateData(element.value);
  }

  updateData(value) {
    
    let bisSelect = document.querySelector('#notify_variant'); 
    let updateCurrentVariant = this.querySelector('.current-variant');  
    if(value) {
      for(var i = 0; i < bisSelect.length; i++) {

        if(bisSelect[i].text == value) {
          bisSelect.selectedIndex = i;
          updateCurrentVariant.innerText = value;
          break;
        }
      }
    } else {
      bisSelect.selectedIndex = 0;
      updateCurrentVariant.innerText = bisSelect[0].getAttribute('value-size');
    }
  }

  addEvents() {

    subscribe(PUB_SUB_EVENTS.sidebarOpen, (event) => {
      this.open(event)
    });

    this.button.addEventListener('click', (event)  => {
      event.preventDefault();
      this.classList.remove('notification');
      if(this.privacy.checked) {
          const email       = this.email.value,
                productId   = this.select.getAttribute('data-product'),
                variantId   = this.select.value

          const email_regex = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|'(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*')@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;

          if(email.match(email_regex)){

            // Back in stock API
            BIS.create(email, variantId, productId)
              .then(this.notificationCallback())
              this.classList.add('notification');
            setTimeout(() => {
              this.email.value = "";
            }, 3000);

          } else {
            this.email.closest(".field").classList.add('field--error');
          }

      } else {
        this.privacyField.classList.add('field--error');
      }
    })
    this.email.addEventListener("click", ()=>{
      if(this.email.closest(".field").classList.contains("field--error")){
        this.email.closest(".field").classList.remove("field--error")
      }
    });
    this.privacyField.addEventListener("click", ()=>{
      if(this.privacyField.classList.contains("field--error")){
        this.privacyField.classList.remove("field--error")
      }
    });
  }

  notificationCallback(){
    this.dialog_notify.classList.remove("tw-hidden");
  }
}
customElements.define('notifyme-popup', notifyMePopup);
